import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { type ApiConfig } from '@pkgs/api/types';
import {
  getTrackingByShopId as generatedGetTrackingByShopId,
  type GetTrackingByShopIdResult as GeneratedGetTrackingByShopIdResult,
} from '@generated/search-bff/controllers/tracking-v2/tracking-v2';

/**
 * Returns all tracking ids based on a given master data shop id using the `/api/v2/tracking/shop/{masterDataShopId}` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/tracking/getTrackingByShopId Search API Documentation}
 */
export function getTrackingByShopId(shopId: string, apiConfig: ApiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, 'getTrackingByShopId');
  return generatedGetTrackingByShopId(shopId, _apiConfig);
}

export type GetTrackingByShopIdResult = GeneratedGetTrackingByShopIdResult;
